import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(source, true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(source)).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import types from 'prop-types';
import { compose } from 'recompose';
import { styled, StyleSheet } from '@rexlabs/styling';
import withText from './with-text';
var assign = _Object$assign;
var isArray = _Array$isArray;

var mapTextTypes = function mapTextTypes(text, type) {
  return isArray(type) ? _reduceInstanceProperty(type).call(type, function (acc, t) {
    return _objectSpread({}, acc, {}, text[t]);
  }, {}) : text[type];
};

var Text = function Text(_ref) {
  var _ref$text = _ref.text,
      text = _ref$text === void 0 ? {} : _ref$text,
      type = _ref.type,
      El = _ref.is,
      styles = _ref.styles,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["text", "type", "is", "styles", "children"]);

  return React.createElement(El, _extends({}, props, styles.with('reset')(props, mapTextTypes(text, type))), children);
};

var meta = {
  displayName: 'Text',
  propTypes: {
    is: types.elementType,
    type: types.oneOfType([types.string, types.array]),
    children: types.node
  },
  defaultProps: {
    is: 'span',
    // Ensure `styles.with` pulls in props without verbose code
    style: {}
  }
};
var styles = StyleSheet({
  reset: {
    textTransform: 'none',
    textDecoration: 'none',
    fontSize: '1rem',
    lineHeight: '1.2rem',
    textOverflow: 'ellipsis',
    verticalAlign: 'baseline',
    color: 'inherit',
    fontFamily: 'inherit',
    fontWeight: 'normal',
    fontStyle: 'normal',
    margin: 0,
    padding: 0
  }
});
export default assign(compose(withText, styled(styles))(Text), meta);